import React from 'react';
import PropTypes from 'prop-types';
import css from './CwTable.scss';
import cx from 'classnames';

const CwTable = (props) => {
  const className = cx(
    {
      [props.className]: props.className,
      [css.nested]: props.nested
    },
    (props.alternatingRowColors ? css.tableAlternateRow : css.table)
  );
  return (
    <table style={props.style} className={className}>
      {props.children}
    </table>
  );
};

CwTable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * Set to false if alternating row colors are not desired
   */
  alternatingRowColors: PropTypes.bool,
  /**
   * Whether the table is a nested table and requires different styles.
   */
  nested: PropTypes.bool,
};

CwTable.defaultProps = {
  alternatingRowColors: true
};

export default CwTable;


// WEBPACK FOOTER //
// ./src/components/cwtable/CwTable.jsx